import React from 'react'
import AllFilesAccess from '../components/Apps/Storage/File/Access/AllFilesAccess'

export default function ResearchAndDevelopment() {
    return (
        <div>
            <AllFilesAccess/>
        </div>
    )
}
